module.exports = __webpack_public_path__ + "static/media/Rajkot-Bureau.54659704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Rajkot-Bureau.jpg
// module id = 360
// module chunks = 0